import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonComponent, ButtonLinkComponent, IconComponent } from '@mode/capra';
import { delay, Observable, of, delayWhen } from 'rxjs';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '@mode/shared/ui';

@Component({
  standalone: true,
  selector: 'mode-google-sheet-dataset-failure',
  templateUrl: './google-sheet-dataset-failure.component.html',
  styleUrls: ['./google-sheet-dataset-failure.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ButtonComponent, ButtonLinkComponent, IconComponent, LoaderComponent],
})
export class GoogleSheetDatasetFailureComponent implements OnInit {
  @Output() syncClicked: EventEmitter<void> = new EventEmitter<void>();
  @Input({ required: true })
  spreadsheetUrl = '';
  @Input({ required: true }) isSyncing$!: Observable<boolean>;
  isSyncingWithDelay$ = of(false);
  constructor() {}

  ngOnInit(): void {
    this.isSyncingWithDelay$ = this.isSyncing$.pipe(
      // delay when isSyncing moves from true -> false. There is a flash while other values update and dictate
      // this componets life.  This helps keep the loader visible until the parent removes this component
      delayWhen((isSyncing) => {
        const delayDuration = !isSyncing ? 500 : 0;
        return of(isSyncing).pipe(delay(delayDuration));
      })
    );
  }

  onSyncClicked() {
    this.syncClicked.emit();
  }
}
